import {useEffect, useState} from "react"
import {Alert, Button, Card, Form, Spinner} from "react-bootstrap"

const pretty = (value: unknown) => JSON.stringify(value, null, 2)

export default function JsonEditor({
    title,
    value,
    onSave,
    readOnly = false,
}: {
    title: string
    value: unknown
    onSave: (value: any) => Promise<void>
    readOnly?: boolean
}) {
    const [text, setText] = useState(pretty(value))
    const [saving, setSaving] = useState(false)
    const [message, setMessage] = useState<string | null>(null)

    useEffect(() => setText(pretty(value)), [value])

    const save = async () => {
        try {
            setSaving(true)
            await onSave(JSON.parse(text))
            setMessage("Gespeichert")
        } catch (error: unknown) {
            setMessage(error instanceof SyntaxError
                ? "Ungültiges JSON"
                : "Speichern fehlgeschlagen")
        } finally {
            setSaving(false)
        }
    }

    return <Card>
        <Card.Header><strong>{title}</strong></Card.Header>
        <Card.Body>
            {message && <Alert
                variant={message === "Gespeichert" ? "success" : "danger"}>
                {message}
            </Alert>}
            <Form.Control
                as="textarea"
                rows={18}
                value={text}
                onChange={event => setText(event.target.value)}
                readOnly={readOnly}
                style={{fontFamily: "monospace", fontSize: ".8rem"}}
            />
            {!readOnly && <Button className="mt-3" onClick={save}
                disabled={saving}>
                {saving && <Spinner size="sm" className="me-2"/>}
                Speichern
            </Button>}
        </Card.Body>
    </Card>
}
